export class ConstructionDetail {
    public ID: number;
    public HashCode: string;
    public SchoolID: number;
    public YearOfConstruction: any;
    public Phase: string;
    public Area: string;
    public yearID: number;
}